module.exports = __webpack_public_path__ + "img/HT.562ecc7a.png";